import { Component, input } from "@angular/core";
import { CurrencyPipe } from "@angular/common";
import { TPipe } from "../../i18n/t.pipe";

export interface Stat {
  label: string;
  value: string | number | null | undefined;
  currency?: boolean;
  suffix?: string;
  /** primeicons name without the "pi pi-" prefix */
  icon?: string;
  /** the tile that matters most (e.g. the total) */
  highlight?: boolean;
}

@Component({
  standalone: true,
  selector: "app-stat-bar",
  imports: [CurrencyPipe, TPipe],
  template: `
    <div class="stat-bar">
      @for (s of items(); track s.label) {
        <div class="stat" [class.stat-highlight]="s.highlight">
          @if (s.icon) {
            <span class="stat-icon"><i [class]="'pi pi-' + s.icon"></i></span>
          }
          <div class="stat-text">
            <span class="stat-label">{{ s.label | t }}</span>
            <strong class="stat-value">
              @if (s.value === null || s.value === undefined || s.value === "") { - }
              @else if (s.currency) { {{ s.value | currency: "EUR" : "symbol" }} }
              @else { {{ s.value }}@if (s.suffix) {<small>{{ s.suffix | t }}</small>} }
            </strong>
          </div>
        </div>
      }
    </div>
  `,
  styles: [`
    .stat-bar { display: grid; grid-template-columns: repeat(auto-fit, minmax(10.5rem, 1fr)); gap: .75rem; }
    .stat { display: flex; align-items: center; gap: .85rem; padding: .9rem 1.1rem; background: #fff;
      border: 1px solid #e5e7eb; border-radius: 10px; }
    .stat-icon { flex: none; display: grid; place-items: center; width: 2.4rem; height: 2.4rem;
      border-radius: 8px; background: #f1f5f9; color: #475569; font-size: 1.05rem; }
    .stat-text { display: flex; flex-direction: column; min-width: 0; }
    .stat-label { font-size: .7rem; font-weight: 600; letter-spacing: .06em; text-transform: uppercase; color: #64748b; }
    .stat-value { font-size: 1.35rem; font-weight: 700; line-height: 1.25; color: #0f172a; white-space: nowrap; }
    .stat-value small { margin-left: .3rem; font-size: .8rem; font-weight: 500; color: #64748b; }
    .stat-highlight { background: #0f766e; border-color: #0f766e; }
    .stat-highlight .stat-icon { background: rgba(255,255,255,.18); color: #fff; }
    .stat-highlight .stat-label { color: rgba(255,255,255,.8); }
    .stat-highlight .stat-value { color: #fff; }
  `],
})
export class StatBarComponent {
  readonly items = input<Stat[]>([]);
}
